<script setup>

import {useStore} from "vuex";
const store = useStore();

import { ref, getCurrentInstance, onMounted, computed } from "vue";
import { Link } from "@inertiajs/vue3";

const appInstance = getCurrentInstance();
const emitter = appInstance.appContext.config.globalProperties.emitter;

// Define popups array
const popups = computed(() => {
  return store.state.central.popups;
});

const activePopup = ref(null);


// If emitter is defined (we don't have emitter in ssr)
if (emitter) {

      // Listen for appLoaded:seconds event
      emitter.on("appLoaded:seconds", (seconds) => {

      // If popups is null, return
      if (popups.value === null || popups.value.length === 0) return;

      const currentPopup = popups.value.find(popup => {
        return seconds == popup.delay_seconds;
      });

      if (currentPopup) {
        activePopup.value = currentPopup;
      }

    });

}

onMounted(() => {

  if (store.state.central.popups === null){
    axios.get(route("popups.index")).then(response => {
      store.commit("central/set", {
        popups: response.data
      });
    });
  }


});

const close = () => {
  activePopup.value = null;
};


</script>

<template>

  <Transition name="fade-y">
    <div class="popupWrapper small" style="position: fixed; right: 10px; bottom: 10px; width: 250px; height: 250px; z-index: 10; box-shadow: 0px 0px 7px rgba(0,0,0,0.2)" v-if="activePopup">
      <i class="popupClose lnr small icon-cross cursor-pointer p-1 text-black bg-white rounded-5" style="font-size: 10px !important;" @click="close()"></i>
      <Link :href="activePopup.link">
        <img :src="activePopup.image" :alt="activePopup.name" class="w-100 h-100">
      </Link>
    </div>
  </Transition>


</template>

<style scoped>

</style>